import register from 'ShopUiBundle/modules/app/registry';

// tslint:disable-next-line
register('bike-detail-dynamic-loader', () => import(/* webpackMode: "lazy" */'./bike-detail-dynamic-loader'));
